<template>
  <div>
    <div class="grid grid-cols-1 md:grid-cols-2">

      <div class="h-full md:h-screen topo flex flex-col md:flex-row justify-center">

        <img class="ml-auto pr-10 mobile" src="@/assets/images/novaintegracao/avatar-novo.svg" alt="avatar"/>

        <img class=" md:px-0 px-10 mx-auto" src="@/assets/images/novaintegracao/logo-nova.svg" alt="">

      </div>

      <div>

        <div class="header descktop mt-10"
             style="background-image: url('../../assets/images/novaintegracao/header-bg.png');">
          <div class="grid grid-cols-1 md:grid-cols-2 flex-wrap justify-between">

            <div class="m-auto text-center md:text-left azulwdc">
              <p>PASSO SEIS</p>
              <h3 class="azulwdc">Avaliação do <strong>Conteúdo</strong></h3>
            </div>
            <div class="flex my-auto mx-auto desktop">
              <h3 class="my-auto azulwdc "> Olá <strong>{{ userisloged.name }}!</strong></h3>
              <img class="ml-3" src="@/assets/images/novaintegracao/avatar-novo.svg" alt="avatar"/>
            </div>
          </div>

        </div>

        <form class="perguntas mt-8 mx-auto w-10/12" @submit.prevent="submitForm">
          <div class="pergunta" v-for="(pergunta, index) in perguntas">
            <div class="flex items-center azulwdc">
              <h2 class="text-3xl md:text-4xl pr-3 font-black">0{{ index + 1 }}</h2>
              <h1 class="text-base md:text-xl pl-3 font-black">{{ pergunta.titulo }}</h1>
            </div>

            <ul class="centerx grid grid-cols-2 lg:grid-cols-5 my-4">
              <li>
                <vs-radio v-validate="'required'" color="danger" v-model="respostas[index]" :vs-value="index + '5'">
                  Otima
                </vs-radio>
              </li>
              <li>
                <vs-radio v-validate="'required'" color="danger" v-model="respostas[index]" :vs-value="index + '4'">
                  Boa
                </vs-radio>
              </li>
              <li>
                <vs-radio v-validate="'required'" color="danger" v-model="respostas[index]" :vs-value="index + '3'">
                  Regular
                </vs-radio>
              </li>
              <li>
                <vs-radio v-validate="'required'" color="danger" v-model="respostas[index]" :vs-value="index + '2'">
                  Ruim
                </vs-radio>
              </li>
              <li>
                <vs-radio v-validate="'required'" color="danger" v-model="respostas[index]" :vs-value="index + '1'">
                  Péssima
                </vs-radio>
              </li>
            </ul>
          </div>
          <div class="pergunta">
            <div class="flex items-center azulwdc">
              <h2 class="text-3xl md:text-4xl pr-3 font-black">0{{ perguntas.length + 1 }}</h2>
              <h1 class="text-base md:text-xl pl-3 font-black">O que você gostaria de acrescentar?</h1>
            </div>
            <textarea v-validate="'required'" name="text" class="w-full" id="comment" v-model="descritiva"
                      placeholder="Digite aqui sua resposta..."></textarea>

          </div>
          <span class="text-danger text-sm" v-show="danger"> {{ danger }}</span>
          <div class="flex justify-end p-4">
            <button
              class="botao-enviar p-4 bg-vermelhowdc border-none text-lg  text-white font text-center w-48 cursor-pointer"
              type="submit"> Enviar
            </button>
          </div>

        </form>
      </div>
    </div>
  </div>


</template>

<script>

export default {
  name: "Numeros",
  props: [],
  created() {
    if (!this.userisloged) {
      this.$router.push({name: 'novaintegracao-login'})
    }
  },
  data() {
    return {
      pronome: 'a',
      animation_path: [],
      width: window.innerWidth,
      descritiva: '',
      danger: '',
      radios2: 'otima',
      perguntas: [
        {
          titulo: 'Como foi sua experiência na plataforma?',
          respostas: [
            {
              texto: 'Otima'
            },
            {
              texto: 'Boa'
            },
            {
              texto: 'Regular'
            },
            {
              texto: 'Ruim'
            },
            {
              texto: 'Péssima'
            },
          ]
        },
        {
          titulo: 'O Culture Code é:',
          respostas: [
            {
              texto: 'Otima'
            },
            {
              texto: 'Boa'
            },
            {
              texto: 'Regular'
            },
            {
              texto: 'Ruim'
            },
            {
              texto: 'Péssima'
            },
          ]
        },
        {
          titulo: 'Qual é alternativa correta?',
          respostas: [
            {
              texto: 'Otima'
            },
            {
              texto: 'Boa'
            },
            {
              texto: 'Regular'
            },
            {
              texto: 'Ruim'
            },
            {
              texto: 'Péssima'
            },
          ]
        },
      ],
      respostas: ["5", "5", "5", "5", "5"]
    }
  },
  methods: {
    next(step) {
      this.$store.dispatch('integracao/setStep', step).then(() => {
        this.$router.push({name: 'integracao-' + this.$store.state.integracao.page});
      })
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {

          this.$store.dispatch('integracao/storefeedback', {
            resp1: this.respostas[0],
            resp2: this.respostas[1],
            resp3: this.respostas[2],
            resp4: this.descritiva,
            user:this.userisloged.id
          }).then(() => {
            this.danger = '';
            this.$router.push({name: 'integracao-fim'})
          })
        } else {
          this.danger = "Todos os campos devem ser preenchidos"
        }
      })
    }
  },
  watch: {
    windowWidth() {
      this.width = window.innerWidth;
    }
  },
  updated() {

  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth
    },
    userisloged() {
      let user = localStorage.getItem('integracaoLogged')
      return JSON.parse(user);
    },
    respostasReais() {
      let array = []
      this.respostas.forEach((resp) => {
        array.push(resp.substring(1, 2));
      });
      return array
    }
  }
}
</script>

<style scoped>
.topo {
  background-image: url('../../assets/images/novaintegracao/bg-topo.png') !important;
  background-size: cover;
}

.pergunta h2 {
  border-right: 4px #C61517 solid;
}

.centerx ul {
  list-style: none !important;
}

ul li::before {
  content: '';
}


.vs-radio--borde {
  border: 2px solid #C61517;
}

textarea {
  width: 100%;
  height: 150px;
  line-height: 150%;
  resize: vertical;
  border-radius: 7px;
  border: 1px #CBCBCB solid;
  font-size: 18px !important;
  font-family: 'Roboto', sans-serif !important;
  padding: 15px;
  margin-top: 20px;

}


textarea::placeholder {
  font-size: 18px !important;
  font-family: 'Roboto', sans-serif !important;
  color: #D2D2D2;
  padding: 15px;
}

button:hover {
  background-color: #8a0f11 !important;
  transition: 200ms;
}

.mobile {
  display: none;
}

@media (max-width: 767px) {
  .desktop {
    display: none !important;
  }

  .mobile {
    display: flex;
  }
}

</style>
